import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import "./App.css";
import { AuthProvider, useAuth } from "./context/authContext";
import { DialogProvider } from "./context/dialogContext";
import PrivateRoute from "./components/PrivateRoute";

import Login from "./Login";
import Operar from "./pages/Operar";
import Admin from "./pages/Admin";
import Rutas from "./pages/Rutas";

// Redirige la raíz según el rol del usuario.
function Inicio() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.tipo === "personal" ? "/rutas" : "/operar"} replace />;
}

function App() {
  return (
    <AuthProvider>
      <DialogProvider>
        <BrowserRouter>
          <Routes>
          <Route path="/login" element={<Login />} />

          <Route path="/" element={<Inicio />} />

          <Route
            path="/operar"
            element={
              <PrivateRoute allowedRoles={["llaves"]}>
                <Operar />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <PrivateRoute allowedRoles={["llaves"]}>
                <Admin />
              </PrivateRoute>
            }
          />
          <Route
            path="/rutas"
            element={
              <PrivateRoute allowedRoles={["llaves", "personal"]}>
                <Rutas />
              </PrivateRoute>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </DialogProvider>
    </AuthProvider>
  );
}

export default App;
